import { useTranslations } from "next-intl";
import CustomIcon from "@/components/ui/custom-icon";
import S from "./index.module.scss";

const EmptyFavoritesList = () => {
  const t = useTranslations();
  const text = t.rich("favoriteBtn", {
    icon: (
      <span className={S.iconButtonWrapper}>
        <CustomIcon fileName="icon-heart-black" />
      </span>
    ) as unknown as string,
  });

  return <div className={S.emptyWrap}>{text}</div>;
};

export default EmptyFavoritesList;
